import {
    formatDate, formatDaysRemaining, formatDuration, formatNumber,
    formatStyle, formatSuffix, formatText
} from "../utilities/FormatUtilities";
import React from "react";

export const getInsightDateVariance = (actual, baseline, insight) => {

    // Console logging flag
    const logToConsole = false;

    // DEFAULTS
    const actualDate = new Date(actual);
    // console.log('actualDate: {0}'.format(actualDate))
    const baselineDate = new Date(baseline[insight.field.name]);
    // console.log('baselineDate: {0}'.format(baselineDate))

    // Get the Insight return value/metric
    let metric;
    switch (insight.effect.metric.type) {
        case 'duration':
            metric = formatDuration(baselineDate, actualDate, insight.effect.metric);
            break;
        case 'daysremaining':
            metric = formatDaysRemaining(actualDate, insight.effect.metric);
            break;
        default:
            metric = actualDate;
            break;
    }

    // Get the return styling
    let formatActualAndInsight;
    switch (insight.effect.equality) {
        case '>':
            formatActualAndInsight = actualDate > baselineDate;
            break;
        case '<':
            formatActualAndInsight = actualDate < baselineDate;
            break;
        case '=':
            formatActualAndInsight = actualDate === baselineDate;
            break;
        default:
            formatActualAndInsight = false;
            break;
    }

    const insightObj = {formatActualAndInsight: formatActualAndInsight, metric: metric}

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getInsightDateVariance', 'font-weight: bold; color: none',
            '\n' + ' - actual.typeof:', typeof actual,
            '\n' + ' - baseline.typeof:', typeof baseline,
            '\n' + ' - insight.typeof:', typeof insight,
            '\n' + ' - insightObj.typeof:', typeof insightObj + '\n',
            { actual },
            { baseline },
            { insight },
            { insightObj }
        );
    }

    return insightObj;
};

export const getInsightNumberVariance = (actual, baseline, insight) => {

    // Console logging flag
    const logToConsole = false;

    // DEFAULTS
    if ((!(actual) || isNaN(actual)) && actual !== 0) {
        // console.log('Returning Actual --');
        return '--';
    }

    const baselineNum = baseline[insight.field.name];
    // console.log('BASELINE NUM: {0}'.format(baselineNum));
    if ((!(baselineNum) || isNaN(baselineNum)) && baselineNum !== 0) {
        // console.log('Returning Baseline --');
        return '--';
    }
    // console.log('actual: {0}'.format(actual));
    // console.log('baseline: {0}'.format(baselineNum));

    const diff = actual - baselineNum
    const metric = formatNumber(diff, insight.effect.metric.numberFormatter);

    // Get the return styling
    let formatActualAndInsight;
    switch (insight.effect.equality) {
        case '>':
            formatActualAndInsight = actual > baselineNum;
            break;
        case '<':
            formatActualAndInsight = actual < baselineNum;
            break;
        case '=':
            formatActualAndInsight = actual === baselineNum;
            break;
        default:
            formatActualAndInsight = false;
            break;
    }

    const insightObj = {formatActualAndInsight: formatActualAndInsight, metric: metric}

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getInsightNumberVariance', 'font-weight: bold; color: none',
            '\n' + ' - actual.typeof:', typeof actual,
            '\n' + ' - baseline.typeof:', typeof baseline,
            '\n' + ' - insight.typeof:', typeof insight,
            '\n' + ' - insightObj.typeof:', typeof insightObj + '\n',
            { actual },
            { baseline },
            { insight },
            { insightObj }
        );
    }

    return insightObj;
};